(() => {
  const text = JSON.parse(document.getElementById('panta-ux-text').textContent);
  const states = new Map();
  const labels = new WeakMap();
  const initialVariant = new URL(location.href).searchParams.has('variant');
  const key = picker => `${picker.getAttribute('form-id')}:${picker.getAttribute('handle')}`;
  const stateFor = picker => {
    if (!states.has(key(picker))) states.set(key(picker), { chosen: initialVariant, busy: false });
    return states.get(key(picker));
  };
  const update = () => {
    document.querySelectorAll('variant-picker[context="main_product"]').forEach(picker => {
      const field = picker.querySelector('[data-panta-size-choice]');
      if (!field) return;
      const state = stateFor(picker);
      const form = document.getElementById(picker.getAttribute('form-id'));
      if (!form) return;
      const pending = !state.chosen;
      field.querySelectorAll('input[type="radio"]').forEach(input => {
        if (input.checked) input.dataset.pantaFallback = 'true';
        else delete input.dataset.pantaFallback;
      });
      if (pending && !state.busy) field.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
      const hint = field.querySelector('.panta-size-hint');
      if (hint) hint.hidden = !pending;
      field.querySelectorAll('label.is-disabled').forEach(label => {
        const input = document.getElementById(label.htmlFor);
        if (input && !input.hasAttribute('aria-label')) input.setAttribute('aria-label', `${label.textContent.trim()} – ${text.unavailable}`);
      });
      form.querySelectorAll('button[type="submit"]').forEach(button => {
        if (!labels.has(button)) labels.set(button, button.innerHTML);
        const next = state.busy ? text.updating : pending ? text.choose : labels.get(button);
        if (button.innerHTML !== next) button.innerHTML = next;
        if (state.busy) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      });
      form.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = pending || state.busy; });
    });
  };
  document.addEventListener('change', event => {
    const input = event.target.closest('input[data-option-position]');
    const picker = input?.closest('variant-picker[context="main_product"]');
    const field = picker?.querySelector('[data-panta-size-choice]');
    if (!field) return;
    const state = stateFor(picker);
    if (field.contains(input)) state.chosen = true;
    else if (!state.chosen) {
      const fallback = field.querySelector('input[data-panta-fallback]') || field.querySelector('input');
      if (fallback) fallback.checked = true;
    }
    state.busy = true;
    update();
  }, true);
  document.addEventListener('variant:change', event => {
    const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(event.target.getAttribute('id') || event.detail.formId)}"]`);
    if (picker) {
      stateFor(picker).busy = false;
      update();
    }
  });
  document.addEventListener('submit', event => {
    const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(event.target.getAttribute('id') || '')}"][context="main_product"]`);
    const field = picker?.querySelector('[data-panta-size-choice]');
    if (!field) return;
    const state = stateFor(picker);
    if (state.chosen && !state.busy) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!state.chosen) {
      field.scrollIntoView({ block: 'center', behavior: 'smooth' });
      field.querySelector('input[type="radio"]')?.focus({ preventScroll: true });
    }
  }, true);
  let queued = false;
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('variant-picker,product-form,buy-buttons') || node.querySelector('variant-picker,product-form,buy-buttons'))))) return;
    if (!queued) {
      queued = true;
      queueMicrotask(() => { queued = false; update(); });
    }
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', update);
  update();
})();
